export const arrayFieldStyles = {
  container: {
    width: '100%',
  },
  label: {
    marginBottom: '16px',
    fontWeight: 500,
    color: 'text.primary',
  },
  proposalCard: {
    marginBottom: '16px',
    border: '1px solid',
    borderColor: 'divider',
    '&:hover': {
      borderColor: 'primary.main',
    },
  },
  proposalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  proposalTitle: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: 'primary.main',
  },
  deleteButton: {
    color: 'error.main',
    '&:hover': {
      backgroundColor: 'error.light',
      color: 'error.contrastText',
    },
  },
  divider: {
    marginBottom: '16px',
    border: 'none',
    borderTop: '1px solid',
    borderColor: 'divider',
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  addButton: {
    marginTop: '16px',
    width: '100%',
    padding: '12px',
    borderStyle: 'dashed',
    borderWidth: 2,
    '&:hover': {
      borderStyle: 'solid',
      backgroundColor: 'primary.light',
      color: 'primary.contrastText',
    },
  },
};
